import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';

import { Popover } from 'antd';
import {
  formatUnits,
  parseUnits,
} from 'ethers';
import { useTranslation } from 'react-i18next';

import {
  swapAgreementCost,
  tokenArr,
} from '@/collocate';
import BalanceCom from '@/components/BalanceCom';
import Icon from '@/components/Icon';
import useBestTradeExactIn from '@/hooks/useBestTradeExactIn';
import useControllablePolling from '@/hooks/usePollingEffect';
import arrows from '@/image/arrows.svg';
import { formatTo6Decimals } from '@/utils';

const Cost = forwardRef(({ amountIn, amountOutMin, fromAddress, toAddress, fromSymbol, slippage, toSymbol, path }: {
    amountIn: bigint,
    amountOutMin: bigint,
    fromAddress: string,
    toAddress: string,
    fromSymbol: string,
    toSymbol: string
    slippage: string,
    path: string[]
}, ref) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    // 定义子组件暴露出去的方法
    useImperativeHandle(ref, () => ({
        getBestTradePathCall: () => {
            getBestTradePath();
        },
    }));

    const {
        bestTrade, bestTradeExactInLod, getBestTradePath
    } = useBestTradeExactIn(fromAddress, toAddress, parseUnits('1')); // 获取兑换比例 hook
    const getSymbolsFromPath = useCallback((): string[] => {
        return bestTrade.path.map((address) => {
            const token = tokenArr.find((t) => t.address.toLowerCase() === address.toLowerCase());
            return token ? token.symbol : 'UNKNOWN';
        });
    }, [bestTrade]);
    const dataList = useMemo(() => {
        const symbols = getSymbolsFromPath()
        const symbolPath = symbols.join(' - ');
        return [
            { text: t('home.minimumReceived'), value: `${formatTo6Decimals(formatUnits(amountOutMin))}${toSymbol}` },
            { text: `${t('home.fee')}（${swapAgreementCost}%）`, value: `${formatTo6Decimals(formatUnits(amountIn * BigInt(swapAgreementCost * 100), 22))}${fromSymbol}` },
            { text: t('home.orderRouting'), value: `F-SWAP API` },
            { text: t('home.bestPath'), value: `${symbolPath}` },
            { text: t('home.slippageTolerance'), value: `${slippage}%` }
        ]
    }, [amountIn, amountOutMin, fromSymbol, getSymbolsFromPath, slippage, t, toSymbol])
    useControllablePolling(() => {
        getBestTradePath()
    }, 10000, (path.length && fromAddress && toAddress && !bestTradeExactInLod), false)
    const content = useMemo(() => {
        return <div className=' text-xs text-3d  w-costPopoverW  md:w-130.5'>
            {dataList.map((item, index) => {
                return <div key={index} className='pb-2.5 last:pb-0 '>
                    <div className='flex items-center justify-between '><span>{item.text}</span><span>{item.value}</span></div>
                </div>
            })}
        </div>
    }, [dataList])
    return (
        <Popover
            open={open}
            onOpenChange={handleOpenChange}
            className={` ${fromAddress && toAddress && path.length ? '' : 'hidden'}`} content={content} placement='bottomRight'>
            <div className='flex items-center justify-between cursor-pointer'>
                <div className="text-66 text-xs flex items-center">1{fromSymbol} = <BalanceCom className='pl-1' balance={bestTrade.amountOut} loading={bestTradeExactInLod} /> {toSymbol}</div>
                <div className='text-aa flex items-center text-xs'>
                    <Icon src={arrows} className={`w-3 mr-1.25 text-4e ml-1.25 cursor-pointer ${open ? '-rotate-180' : ''} transition duration-300`} />
                </div>
            </div >
        </Popover>
    )
})



export default Cost